import React, { useState, useCallback } from 'react';
import MainSidebar from 'components/ui/MainSidebar';
import CommunityRoomSelector from 'components/ui/CommunityRoomSelector';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';
import PostCard from './components/PostCard';
import CreatePostModal from './components/CreatePostModal';
import MemberSpotlight from './components/MemberSpotlight';
import TrendingTopics from './components/TrendingTopics';
import WeeklyChallenge from './components/WeeklyChallenge';
import LiveEventBanner from './components/LiveEventBanner';
import Button from 'components/ui/Button';


const INITIAL_POSTS = [
{
  id: 1,
  author: "Keisha Williams",
  role: "Stock Market Educator · Pinnacle Member",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e478ca3e-1772215168921.png",
  avatarAlt: "African American woman with natural hair wearing gold earrings and professional attire smiling warmly",
  badge: "Top Mentor",
  type: "insight",
  title: "Why I\'m Bullish on Dividend Stocks in 2026",
  content: "With interest rates stabilizing, dividend-paying stocks are becoming increasingly attractive. I've been adding positions in REITs and utility companies. The key is to look for companies with 10+ years of consecutive dividend growth. Here's my current watchlist... 📈",
  tags: ["dividends", "investing", "2026strategy"],
  reactions: { coin: 47, insight: 31, crown: 12 },
  comments: 23,
  timeAgo: "2h ago",
  image: null,
  imageAlt: null
},
{
  id: 2,
  author: "Priya Sharma",
  role: "Real Estate Investor · Pinnacle Member",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14172f3b5-1763301352044.png",
  avatarAlt: "Professional Indian woman with long dark hair wearing elegant navy blazer smiling confidently",
  badge: "WIN Verified",
  type: "milestone",
  title: "🎉 Just closed on my 5th rental property!",
  content: "After 3 years of learning, saving, and networking through WIN, I just closed on my 5th rental property in Atlanta! Total portfolio value: $1.2M. This community has been everything. Thank you to my mentor @Keisha and everyone who answered my endless questions in the Real Estate room! 🏠✨",
  tags: ["milestone", "realestate", "WINcommunity"],
  reactions: { coin: 128, crown: 89, insight: 15, support: 34 },
  comments: 67,
  timeAgo: "5h ago",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_151ff65bf-1772868865271.png",
  imageAlt: "Beautiful modern suburban home with manicured lawn and two-car garage in Atlanta neighborhood"
},
{
  id: 3,
  author: "Amara Johnson",
  role: "Beginner Investor · Seed Member",
  avatar: "https://images.unsplash.com/photo-1699461073079-e8edde34699f",
  avatarAlt: "Young African American woman with braided hair wearing casual professional attire looking thoughtful",
  badge: null,
  type: "question",
  title: "Best ETFs for a beginner with $500/month to invest?",
  content: "Hi WIN family! I'm 27, just started my investment journey 3 months ago. I have $500/month to invest consistently. Currently looking at VTI, SCHD, and QQQ. Should I diversify across all three or focus on one? My goal is long-term wealth building (20+ year horizon). Any advice from experienced investors here? 🙏",
  tags: ["beginner", "ETFs", "advice"],
  reactions: { coin: 34, insight: 28, support: 19 },
  comments: 41,
  timeAgo: "8h ago",
  image: null,
  imageAlt: null
},
{
  id: 4,
  author: "Sofia Chen",
  role: "Tech Entrepreneur · Growth Member",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_120e006a3-1763296011897.png",
  avatarAlt: "Asian woman with sleek black hair wearing modern business casual attire in professional setting",
  badge: "WIN Verified",
  type: "spotlight",
  title: "FemTech Solutions - Seeking $250K Seed Round",
  content: "Excited to share that my company FemTech Solutions is now live on the WIN Investment Opportunities board! We're building AI-powered financial planning tools specifically designed for women. 18 months in, $45K ARR, and growing 40% MoM. Looking for aligned investors who believe in our mission. DM me or check the opportunities board! 💪",
  tags: ["startup", "femtech", "investing", "WomenLed"],
  reactions: { coin: 56, crown: 43, insight: 22 },
  comments: 38,
  timeAgo: "1d ago",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14c37ece4-1772523947054.png",
  imageAlt: "Modern tech startup office with diverse team of women collaborating around laptops and whiteboards"
},
{
  id: 5,
  author: "Rachel Torres",
  role: "Financial Advisor · Growth Member",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1acbb5c55-1763298682729.png",
  avatarAlt: "Latina woman with shoulder-length brown hair wearing professional blazer in office environment",
  badge: null,
  type: "poll",
  title: "What\'s your primary investment focus in 2026?",
  content: "Curious where the WIN community is putting their money this year. Vote below and share your reasoning in the comments!",
  tags: ["poll", "investing2026"],
  pollOptions: [
  { label: "📈 Stock Market (ETFs/Individual Stocks)", pct: 42 },
  { label: "🏠 Real Estate", pct: 31 },
  { label: "🚀 Startups / Venture Capital", pct: 15 },
  { label: "₿ Crypto / Digital Assets", pct: 12 }],

  pollVotes: "312",
  pollEnds: "2 days left",
  reactions: { coin: 18, insight: 24 },
  comments: 29,
  timeAgo: "1d ago",
  image: null,
  imageAlt: null
}];


const SUGGESTED_MEMBERS = [
{
  id: 1,
  name: "Diana Park",
  role: "Venture Capitalist",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_12b99776f-1772775453515.png",
  avatarAlt: "Korean American woman with stylish short hair wearing elegant business attire",
  badge: "Pinnacle",
  mutual: 12
},
{
  id: 2,
  name: "Tanya Brooks",
  role: "Real Estate Agent",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1fca82876-1763294352035.png",
  avatarAlt: "African American woman with natural curls wearing professional blazer and warm smile",
  badge: "Growth",
  mutual: 8
},
{
  id: 3,
  name: "Mei Lin",
  role: "Portfolio Manager",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_143a229dd-1772794512590.png",
  avatarAlt: "Chinese American woman with long straight hair wearing formal business suit in office",
  badge: "Pinnacle",
  mutual: 15
}];


const FEED_FILTERS = ['All', 'Questions', 'Milestones', 'Spotlights', 'Insights', 'Polls'];

export default function CommunityHub() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeRoom, setActiveRoom] = useState('all');
  const [activeFilter, setActiveFilter] = useState('All');
  const [showCreatePost, setShowCreatePost] = useState(false);
  const [posts, setPosts] = useState(INITIAL_POSTS);
  const [followedMembers, setFollowedMembers] = useState({});

  const sidebarWidth = sidebarCollapsed ? 64 : 240;

  const handleNewPost = useCallback((postData) => {
    const newPost = {
      id: Date.now(),
      author: "Sarah Mitchell",
      role: "Growth Member · Intermediate Investor",
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18c02c6b1-1772546701473.png",
      avatarAlt: "Professional woman with dark hair wearing business casual attire smiling",
      badge: null,
      reactions: {},
      comments: 0,
      timeAgo: "Just now",
      image: null,
      imageAlt: null,
      ...postData
    };
    setPosts((prev) => [newPost, ...prev]);
  }, []);

  const filteredPosts = posts?.filter((p) => {
    if (activeFilter === 'All') return true;
    const map = { Questions: 'question', Milestones: 'milestone', Spotlights: 'spotlight', Insights: 'insight', Polls: 'poll' };
    return p?.type === map?.[activeFilter];
  });

  const toggleFollow = (id) => setFollowedMembers((prev) => ({ ...prev, [id]: !prev?.[id] }));

  return (
    <div className="min-h-screen" style={{ background: 'var(--color-surface)' }}>
      <MainSidebar isCollapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} />
      {/* Main Content */}
      <div
        className={`transition-all duration-250 min-h-screen pb-20 lg:pb-0 ${sidebarCollapsed ? 'lg:ml-[64px]' : 'lg:ml-[240px]'}`}>
        
        {/* Page Header */}
        <header className="sticky top-0 z-40 border-b px-4 md:px-6 lg:px-8" style={{ background: 'var(--color-background)', borderColor: 'var(--color-border)', height: 'var(--header-height)' }}>
          <div className="h-full flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 pl-12 lg:pl-0">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: 'rgba(133,113,77,0.12)' }}>
                <Icon name="Users" size={20} color="var(--color-accent)" />
              </div>
              <div>
                <h1 className="font-heading font-semibold text-lg md:text-xl" style={{ color: 'var(--color-foreground)' }}>Community Hub</h1>
                <p className="font-caption text-xs hidden sm:block" style={{ color: 'var(--color-muted-foreground)' }}>Connect · Learn · Grow Together</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button className="relative p-2 rounded-lg hover:bg-gray-100 transition-colors">
                <Icon name="Bell" size={20} color="var(--color-muted-foreground)" />
                <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full" style={{ background: '#DC2626' }} />
              </button>
              <button className="p-2 rounded-lg hover:bg-gray-100 transition-colors">
                <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
              </button>
              <Button variant="default" size="sm" iconName="Plus" iconPosition="left" iconSize={14} onClick={() => setShowCreatePost(true)} className="hidden sm:flex">
                Post
              </Button>
            </div>
          </div>
        </header>

        <div className="px-4 md:px-6 lg:px-8 py-4 md:py-6">
          {/* Live Event Banner */}
          <div className="mb-4">
            <LiveEventBanner />
          </div>

          {/* Room Selector */}
          <div className="mb-4">
            <CommunityRoomSelector activeRoom={activeRoom} onRoomChange={setActiveRoom} isMobile={false} className="hidden md:flex" />
            <CommunityRoomSelector activeRoom={activeRoom} onRoomChange={setActiveRoom} isMobile={true} className="md:hidden" />
          </div>

          {/* Main Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
            {/* Feed Column */}
            <div className="lg:col-span-2 xl:col-span-3 space-y-4">
              {/* Create Post Card */}
              <div className="bg-white rounded-xl border p-4" style={{ borderColor: 'var(--color-border)' }}>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <Image src="https://img.rocket.new/generatedImages/rocket_gen_img_1722a21c9-1772219085230.png" alt="Current user Sarah Mitchell profile photo with dark hair and professional smile" className="w-full h-full object-cover" />
                  </div>
                  <button
                    onClick={() => setShowCreatePost(true)}
                    className="flex-1 text-left px-4 py-2.5 rounded-full border font-caption text-sm transition-all hover:border-amber-400"
                    style={{ borderColor: 'var(--color-border)', color: 'var(--color-muted-foreground)', background: 'var(--color-surface)' }}>
                    
                    Share an insight, question, or milestone...
                  </button>
                </div>
                <div className="flex gap-1 overflow-x-auto">
                  {[
                  { icon: 'HelpCircle', label: 'Question', color: '#3B82F6' },
                  { icon: 'Trophy', label: 'Milestone', color: '#059669' },
                  { icon: 'Star', label: 'Spotlight', color: '#8B5CF6' },
                  { icon: 'BarChart2', label: 'Poll', color: '#EC4899' }]?.
                  map((item) =>
                  <button key={item?.label} onClick={() => setShowCreatePost(true)}
                  className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-caption font-medium whitespace-nowrap transition-all hover:bg-gray-50 flex-shrink-0"
                  style={{ color: item?.color }}>
                      <Icon name={item?.icon} size={14} color={item?.color} />
                      {item?.label}
                    </button>
                  )}
                </div>
              </div>

              {/* Feed Filters */}
              <div className="flex gap-2 overflow-x-auto pb-1">
                {FEED_FILTERS?.map((f) =>
                <button key={f} onClick={() => setActiveFilter(f)}
                className={`px-3 py-1.5 rounded-full text-xs font-caption font-medium whitespace-nowrap transition-all flex-shrink-0 ${activeFilter === f ? 'text-white' : 'border'}`}
                style={activeFilter === f ?
                { background: 'var(--color-primary)' } :
                { borderColor: 'var(--color-border)', color: 'var(--color-muted-foreground)', background: 'white' }}>
                    {f}
                  </button>
                )}
              </div>

              {/* Posts */}
              {filteredPosts?.length > 0 ?
              filteredPosts?.map((post) => <PostCard key={post?.id} post={post} />) :

              <div className="bg-white rounded-xl border p-8 text-center" style={{ borderColor: 'var(--color-border)' }}>
                  <Icon name="MessageCircle" size={32} color="var(--color-muted-foreground)" className="mx-auto mb-2" />
                  <p className="font-caption text-sm" style={{ color: 'var(--color-muted-foreground)' }}>No posts in this category yet. Be the first!</p>
                </div>
              }

              {/* Load More */}
              <div className="text-center pt-2">
                <Button variant="outline" size="sm" iconName="RefreshCw" iconPosition="left" iconSize={14}>Load More Posts</Button>
              </div>
            </div>

            {/* Right Sidebar */}
            <div className="hidden lg:block space-y-4">
              {/* Weekly Challenge */}
              <WeeklyChallenge />

              {/* Member Spotlight */}
              <MemberSpotlight />

              {/* Trending Topics */}
              <TrendingTopics />

              {/* Suggested Members */}
              <div className="bg-white rounded-xl border overflow-hidden" style={{ borderColor: 'var(--color-border)' }}>
                <div className="px-4 py-3 border-b flex items-center gap-2" style={{ borderColor: 'var(--color-border)' }}>
                  <Icon name="UserPlus" size={16} color="var(--color-accent)" />
                  <h3 className="font-heading font-semibold text-sm" style={{ color: 'var(--color-foreground)' }}>People to Follow</h3>
                </div>
                <div className="divide-y" style={{ borderColor: 'var(--color-border)' }}>
                  {SUGGESTED_MEMBERS?.map((member) =>
                  <div key={member?.id} className="flex items-center gap-3 px-4 py-3">
                      <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                        <Image src={member?.avatar} alt={member?.avatarAlt} className="w-full h-full object-cover" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="font-caption text-sm font-semibold truncate" style={{ color: 'var(--color-foreground)' }}>{member?.name}</p>
                        <p className="font-caption text-xs truncate" style={{ color: 'var(--color-muted-foreground)' }}>{member?.role}</p>
                        <p className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>{member?.mutual} mutual connections</p>
                      </div>
                      <button
                      onClick={() => toggleFollow(member?.id)}
                      className="flex-shrink-0 px-2.5 py-1 rounded-full text-xs font-caption font-medium transition-all border"
                      style={followedMembers?.[member?.id] ?
                      { background: 'var(--color-muted)', color: 'var(--color-muted-foreground)', borderColor: 'var(--color-border)' } :
                      { background: 'var(--color-primary)', color: '#fff', borderColor: 'var(--color-primary)' }}>
                        {followedMembers?.[member?.id] ? 'Following' : 'Follow'}
                      </button>
                    </div>
                  )}
                </div>
                <div className="px-4 py-2.5">
                  <button className="font-caption text-xs font-medium transition-colors hover:opacity-80" style={{ color: 'var(--color-accent)' }}>
                    View all suggestions →
                  </button>
                </div>
              </div>

              {/* Community Stats */}
              <div className="bg-white rounded-xl border p-4" style={{ borderColor: 'var(--color-border)' }}>
                <h3 className="font-heading font-semibold text-sm mb-3" style={{ color: 'var(--color-foreground)' }}>Community Stats</h3>
                <div className="grid grid-cols-2 gap-3">
                  {[
                  { label: 'Members', value: '4,821', icon: 'Users' },
                  { label: 'Posts Today', value: '247', icon: 'MessageSquare' },
                  { label: 'Active Now', value: '312', icon: 'Activity' },
                  { label: 'Investments', value: '$2.4M', icon: 'TrendingUp' }]?.
                  map((stat) =>
                  <div key={stat?.label} className="text-center p-2 rounded-lg" style={{ background: 'var(--color-surface)' }}>
                      <Icon name={stat?.icon} size={16} color="var(--color-accent)" className="mx-auto mb-1" />
                      <p className="font-data font-semibold text-sm" style={{ color: 'var(--color-primary)' }}>{stat?.value}</p>
                      <p className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>{stat?.label}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile FAB */}
      <button
        onClick={() => setShowCreatePost(true)}
        className="sm:hidden fixed bottom-24 right-4 w-14 h-14 rounded-full shadow-xl flex items-center justify-center z-40 btn-fab"
        style={{ background: 'var(--color-accent)' }}
        aria-label="Create new post">
        <Icon name="Plus" size={24} color="var(--color-primary)" />
      </button>
      {/* Create Post Modal */}
      {showCreatePost &&
      <CreatePostModal onClose={() => setShowCreatePost(false)} onPost={handleNewPost} />
      }
    </div>);

}